module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topic"
  }, [_c('h1', {
    staticClass: "pageHeading"
  }, [_vm._v("\n        What Are Your Interests?\n    ")]), _vm._v(" "), _c('p', [_vm._v("Select as many topics as you'd like")]), _vm._v(" "), _c('div', {
    staticClass: "containerBox"
  }, [_c('bs-input', {
    attrs: {
      "type": "text",
      "id": "topic_search",
      "placeholder": "Search Topics"
    }
  }, [_c('span', {
    staticClass: "input-group-addon inputIcon",
    attrs: {
      "slot": "after"
    },
    slot: "after"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-search"
  })])]), _vm._v(" "), _c('button-group', {
    model: {
      value: (_vm.interestIndexes),
      callback: function($$v) {
        _vm.interestIndexes = $$v
      },
      expression: "interestIndexes"
    }
  }, _vm._l((_vm.interests), function(interest, index) {
    return _c('checkbox', {
      key: index,
      staticClass: "min-padding",
      attrs: {
        "true-value": index
      }
    }, [_vm._v("\n                " + _vm._s(interest.interestName) + "\n            ")])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
  }, [_c('button', {
    staticClass: "btn formButton",
    on: {
      "click": function($event) {
        return _vm.proceedUserInfo()
      }
    }
  }, [_vm._v("\n                Done\n                "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)])], 1)])
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dac563f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_live_NgwNoBs3GAlrsSez07Zyh4Jc"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www.tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/assets.tonenetworks.com/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Topic.vue